module.exports = __webpack_public_path__ + "assets/images/Ativ.fisicas.df509b4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/icons/Ativ.fisicas.png
// module id = 792
// module chunks = 1